import './index.css'
import {default as swal} from 'sweetalert2'

// 取得完整的 URL
let url = new URL(window.location.href);
// 解析 URL 中的參數
let searchParams = new URLSearchParams(url.search);
// 取得 agent 參數的值
let agentValue = searchParams.get('agent');

let has_agent = ['test', 'lucifer01', 'JP8', 'fans', 'say', 'mama', 'aAgent', 'bAgent', 'cAgent', 'dAgent', 'dAgent2', 'dAgent3'];
if (searchParams.has('agent') && has_agent.indexOf(agentValue) === -1) {
    swal({
        title: '請檢查代理網址!',
        text: '此代理網址為非法註冊，請聯絡客服！',
        type: 'error',
        confirmButtonText: '確認'
    });
}

$("#register-submit").click(function (event) {
    event.preventDefault();
    send('register', {
        "account": document.getElementById('register-account').value,
        "password": document.getElementById('register-password').value,
        "name": document.getElementById('register-name').value,
        "agent": agentValue,
    });
});

$("#submit").click(function (event) {
    event.preventDefault();
    send('login', {
        "account": document.getElementById('account').value,
        "password": document.getElementById('password').value,
    });
});

function send(url, data) {
    let errorMsg = '請填寫正確帳密或使用ＦＢ進行登入';
    if (url === 'register') {
        errorMsg = '註冊異常，請再次註冊！如無法順利完成請聯絡客服。'
    }

    // fetch(`http://fbpoke.com/php/${url}.php`, {
    fetch(`${process.env.api}php/${url}.php`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'content-type': 'application/json',
        },
        dataType: 'json',
        body: JSON.stringify(data)
    }).then((response) => {
        if (!response.ok) throw new Error(response.statusText);
        return response.json()
    }).then((item) => {
        if (item.msg === 'error') {
            swal(
                '註冊資料規則異常，請正確填寫資料。',
                item,
                'error'
            )
        } else if (item.msg === 'error_1') {
            swal(
                '帳號已註冊！',
                item,
                'error'
            )
        } else {
            item.status = 'DB';
            statusChangeCallback(item);
        }
    }).catch((error) => {
        console.log(error);
        swal(
            errorMsg,
            error,
            'error'
        )
    })
}



// WEBPACK FOOTER //
// ./src/index/index.js